import React, { useEffect, useState, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa';
import { Container, Card, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import axios from '../../services/axios';
import Loading from '../../components/Loading';
import Breadcrumbs from '../../components/Breadcrumbs';
import DataTable from '../../components/DataTable';
import ButtonModal from '../../components/ModalConfirmation/ButtonModal';
import { useNotification } from '../../components/Notification/NotificationContext';
import ErrorProcessor from '../../components/ErrorProcessor';
import CardHeaderMore from '../../components/Cards/CardHeaderMore';

export default function ProductsPage() {
  const routeName = '/products';
  const dataName = 'Produto';
  const navigate = useNavigate();
  const notification = useNotification();
  const [apiErrors, setApiErrors] = useState({});
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { isadmin } = useSelector((state) => state.auth.user);

  const tableColumns = useMemo(() => [
    { Header: 'Nome', accessor: 'name' },
    { Header: 'Ações', accessor: 'actions', noSearch: true },
  ], []);

  useEffect(() => {
    const loadProducts = async () => {
      try {
        setIsLoading(true);
        const { data } = await axios.get(routeName);
        setProducts(data);
      } catch (err) {
        setApiErrors(err);
        setProducts([]);
      } finally {
        setIsLoading(false);
      }
    };
    
    loadProducts();
  }, [routeName]);

  const confirmDelete = async (id) => {
    try {
      setIsLoading(true);
      await axios.delete(`${routeName}/${id}`);
      notification(`${dataName} removido com sucesso`, 'success');
      setProducts(products.filter((product) => product.id !== id));
    } catch (err) {
      setApiErrors(err);
    } finally {
      setIsLoading(false);
    }
  };

  const tableData = useMemo(() => products.map((item) => {
    const linksAction = [
      {
        onclick: () => navigate(`/product/${item.id}/edit`),
        faicon: 'faEdit',
        text: 'Atualizar',
      }
    ];

    if (isadmin === 1) {
      linksAction.push({
        custom: (
          <ButtonModal
            onConfirm={() => confirmDelete(item.id)}
            message={`Confirma remoção do ${dataName} ${item.name}?`}
            buttonProps={{ text: 'Remover', faicon: 'faTrash' }}
            textModal={{ title: `Remover ${dataName}`, textConfirm: 'Remover' }}
            dropdown
          />
        ),
      });
    }

    return {
      name: item.name || 'Nome do produto',
      actions: (
        <div className="d-flex justify-content-between">
          <div>
            {/* Some content on the left side like in the working example */}
            <span>{item.status ? 'Ativo' : 'Inativo'}</span>
          </div>
          <CardHeaderMore links={linksAction} className="" />
        </div>
      ),
      ...item,
    };
  }), [products, navigate, isadmin, dataName]);

  return (
    <Container fluid className="px-lg-4 px-xl-5">
      <Loading isLoading={isLoading} />
      <Breadcrumbs title={dataName} />
      <div className="page-header d-flex justify-content-between align-items-center">
        <h1 className="page-heading">{dataName}</h1>
        {isadmin === 1 && (
          <Link to="/product/new">
            <Button variant="primary" className="text-uppercase">
              <FaPlus /> Cadastrar
            </Button>
          </Link>
        )}
      </div>
      <section>
        <Card className="card-table mb-5">
          <ErrorProcessor error={apiErrors} />
          <DataTable
            items={tableData}
            columns={tableColumns}
            defaultPageSize={5}
          />
        </Card>
      </section>
    </Container>
  );
}